import React, { ReactElement } from 'react';
import { DatePicker, Form, Input } from 'antd';
import { FormItemProps } from 'antd/lib/form';
import moment from 'moment';

import date, { US_LOCALE_DATE_FORMAT } from 'utilities/dates/date';

interface Props extends FormItemProps<string> {
  placeholder?: string;
  disabled?: boolean;
}

const styles = { width: '100%' };

export function FieldDate(props: Props): ReactElement {
  const { name, label, placeholder, required = true, disabled } = props;

  return (
    <Form.Item
      noStyle
      shouldUpdate={(prevValues, curValues) =>
        prevValues[name as string] !== curValues[name as string]
      }
    >
      {(form) => {
        const fieldValue = form.getFieldValue([name as string]);
        const datePickerValue = fieldValue ? moment(fieldValue) : undefined;

        return (
          <Form.Item
            name={name}
            label={label}
            rules={[{ required, message: 'This field is required' }]}
          >
            <>
              <Input hidden />
              <Form.Item noStyle>
                <DatePicker
                  style={styles}
                  format={US_LOCALE_DATE_FORMAT}
                  placeholder={placeholder}
                  data-testid={`field-date-${name}`}
                  value={datePickerValue}
                  disabled={disabled}
                  onChange={(datePicked) => {
                    form.setFieldsValue({
                      [name as string]: datePicked ? date.toISO(datePicked) : undefined,
                    });
                    form.validateFields([name as string]);
                  }}
                />
              </Form.Item>
            </>
          </Form.Item>
        );
      }}
    </Form.Item>
  );
}
